
import Navbar from '@/components/Navbar';
import Header from '@/components/Header';
import HeaderEcom from '@/components/HeaderEcom';
import HeaderEcomBzodUa from '@/components/HeaderEcomBzodUa';
import BarMobile from '~/components/footer/BarMobile';
import BarMobileEcom from '~/components/footer/BarMobileEcom';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { defineAsyncComponent } from 'vue';
import { emitter } from '@/plugins/mitt'; // Добавляем импорт mitt эмиттера
import CertainAdminStyles from '@/mixins/certain-admin-styles';
import Footer from '@/components/footer/Footer';
import FooterMobile from '@/components/footer/FooterMobile';
import cartUpdate from '~/mixins/cart-update';
import dynamicFont from '~/mixins/dynamicFont';
import HeaderCasa from '@/components/HeaderCasa.vue';
import FooterCasa from '@/components/footer/FooterCasa/index.vue';
import MenuMobileCasa from '@/components/header/MenuMobileCasa.vue';
import viewport from '~/mixins/viewport';
import HeaderCategory from '@/components/HeaderCategory.vue';
import CustomFormWrapper from '@/components/custom_forms/CustomFormWrapper.vue';

const components = [];

export default {
    data() {
        return {
            tempCookieData: null,
            isPageLoaded: false,
        };
    },
    components: {
        MenuMobileCasa,
        FooterCasa,
        HeaderCasa,
        Navbar,
        Header,
        HeaderCategory,
        HeaderEcom,
        HeaderEcomBzodUa,
        BarMobile,
        BarMobileEcom,
        Footer,
        FooterMobile,
        ModalFacebookErrorAuth: () => import('@/components/modals/ModalFacebookErrorAuth'),
        MyToast: () => import('@/components/ui/MyToast'),
        AddedToCartNotification: () => import('~/components/modals/notifications/AddedToCartNotification'),
        ModalSuccessCreditCalculator: () => import('~/components/modals/ModalSuccessCreditCalculator'),
        ModalCredit: () => import('~/components/modals/ModalCredit'),
        ModalBuyOneClick: () => import('~/components/modals/ModalBuyOneClick'),
        ProductHeadBanner: () => import('~/components/product/ProductHeadBanner'),
        AddedToFavoritesNotification: () => import('~/components/modals/notifications/AddedToFavoritesNotification'),

        ModalAuthEcom: () => import('@/components/modals/ModalAuthEcom'),
        ModalFirstToKnow: () => import('@/components/modals/ModalFirstToKnow'),
        ModalFirstToKnowSuccess: () => import('@/components/modals/ModalFirstToKnowSuccess'),
        ModalRegisterEcom: () => import('@/components/modals/ModalRegisterEcom'),
        ModalConfirmRegisterMessage: () => import('@/components/modals/ModalConfirmRegisterMessage'),
        ModalResetPasswordEcom: () => import('@/components/modals/ModalResetPasswordEcom'),
        ModalRequestPasswordReset: () => import('@/components/modals/ModalRequestPasswordReset'),
        ModalConfirmResetPasswordMessage: () => import('@/components/modals/ModalConfirmResetPasswordMessage'),

        ModalAgeRestriction: () => import('@/components/modals/ModalAgeRestriction'),
        ModalCitySelection: () => import('@/components/modals/ModalCitySelection'),
        ModalPreorderSuccess: () => import('@/components/modals/ModalPreorderSuccess'),
        ModalError: () => import('@/components/modals/ModalError'),
        ModalCheckoutSuccess: () => import('@/components/modals/ModalCheckoutSuccess'),
        ModalAuth: () => import('@/components/modals/ModalAuth'),
        ModalCheckout: () => import('@/components/modals/ModalCheckout'),
        ModalBuyOneClickSuccess: () => import('@/components/modals/ModalBuyOneClickSuccess'),
        ModalRequestConsultationSuccess: () => import('@/components/modals/ModalRequestConsultationSuccess'),
        ModalCart: () => import('@/components/modals/cart/ModalCart'),
        ModalCreditSuccess: () => import('@/components/modals/ModalCreditSuccess'),
        MenuMobile: () => import('~/components/header/MenuMobile'),
        MenuMobileEcom: () => import('~/components/header/MenuMobileEcom'),
        MenuItemsMobile: () => import('@/components/MenuItemsMobile'),
        ModalPaymentSuccess: () => import('@/components/modals/ModalPaymentSuccess'),
        ModalPreorder: () => import('@/components/modals/ModalPreorder.vue'),
        AddedToCompareNotification: () => import('@/components/modals/notifications/AddedToCompareNotification.vue'),
        ModalAdditionally: () => import('@/components/modals/ModalAdditionally.vue'),
        EcomMyModal: () => import('@/components/modals/EcomMyModal.vue'),
        ModalProfileDeleteSuccess: () => import('~/components/modals/ModalProfileDeleteSuccess.vue'),
        FooterUniplast: () => import('@/components/footer/FooterUniplast'),
        HeaderTertiary: () => import('@/components/header/Tertiary/HeaderTertiary.vue'),
        HeaderTop: () => import('@/components/header/Tertiary/HeaderTop.vue'),
        EcomSubscription: () => import('@/components/EcomSubscription.vue'),
        ModalProductHeadBanner: () => import('~/components/modals/ModalProductHeadBanner.vue'),
        ModalAssociatedProducts: () => import('~/components/modals/ModalAssociatedProducts.vue'),
        CustomFormWrapper,
    },

    mixins: [CertainAdminStyles, cartUpdate, dynamicFont, viewport],
    // setup: () => {
    //     const ModalProductHeadBanner = defineAsyncComponent(async function () {
    //         const { default: component } = await import('~/components/modals/ModalProductHeadBanner');
    //         return component;
    //     });

    //     return {
    //         ModalProductHeadBanner,
    //     };
    // },

    cache: true,

    computed: {
        currentTheme() {
            if (process.client) {
                return this.$store.state.global.theme;
            }
            return this.getTheme;
        },
        shouldUpdateOnQueryChange() {
            return !this.$route?.name?.startsWith('all__') && !this.$route?.name?.startsWith('search__');
        },

        getNuxtKey() {
            return this.shouldUpdateOnQueryChange ? this.$route.fullPath : this.$route.path;
        },
        ...mapGetters([
            'getSelectedCity',
            'getBuyOneClickShowModal',
            'getShowErrorServer',
            'getModalGift',
            'getModalRequestConsultation',
            'getModalRequestConsultationSuccess',
            'showMenuMobile',
            'showMenu',
            'getShowNavigationMobile',
            'getPreorderClickShowModal',
            'getFirstToKnowClickShowModal',
            'getShowShopModal',
            'getShowAgeRestriction',
            'getShowAuth',
            'getShowRegister',
            'getShowRegisterConfirmMessage',
            'getShowSetNewPassword',
            'getShowRequestNewPassword',
        ]),
        ...mapGetters('utms', ['utms']),
        ...mapGetters('cart', [
            'getIsOpenCart',
            'getShowCheckoutModalSuccess',
            'getShowPaymentModalSuccess',
            'getShowFirstToKnowModalSuccess',
            'getShowOneClickModalSuccess',
            'getShowPreorderModalSuccess',
        ]),
        ...mapGetters({
            showCompareNotification: 'compare/getIsShowNotification',
            isNovaPorta: 'global/getIsNovaPorta',
            isHabsev: 'global/getIsHabsev',
            isUniPlast: 'global/getIsUniPlast',
        }),
        ...mapGetters('compare', ['getIsShowModal']),
        ...mapGetters('favorites', ['getIsShowNotification']),
        ...mapGetters('credit', ['getShowModal']),
        ...mapGetters('vacancies', ['getShowModalActiveVacancy', 'getShowModalSendCv', 'getShowModalSendCvSuccess']),
        ...mapGetters('product', ['getBannerShowContent']),

        ...mapGetters({
            globalSettings: 'global/globalSettings',
            isVitrina: 'global/isVitrina',
            footerSettings: 'footer/footerSettings',
            showMobileFiltering: 'filters/showMobileFiltering',
            showMobileSorting: 'filters/showMobileSorting',
            isCasaDelTabaco: 'global/getIsCasaDelTabaco',
            isAuth: 'auth/isAuth',
            noScriptCode: 'global/getNoScriptCode',
            sideBarView: 'global/getSideBarView',
            isModalOrderCheckout: 'global/isModalOrderCheckout',
            getModalByKey: 'global/getModalByKey',
            userData: 'auth/getUserData',
        }),

        isHaveCompanyInUserData() {
            return this.userData?.company;
        },

        getLocaleMessagesB2C() {
            const raw = this.globalSettings?.locale_text?.b_to_c || {};
            return Object.keys(raw).length ? this.stripPTagsDeep(raw) : false;
        },

        getLocaleMessagesB2B() {
            const raw = this.globalSettings?.locale_text?.b_to_b || {};
            return Object.keys(raw).length ? this.stripPTagsDeep(raw) : false;
        },

        customFormsData() {
            return this.globalSettings?.forms?.length ? this.globalSettings?.forms : false;
        },

        isDisplayItemsSharp() {
            return this.globalSettings?.additional_settings?.display_items === 'sharp';
        },

        isDisplay18YearOldModal() {
            return (
                this.globalSettings?.additional_settings?.has_18_permission &&
                this.globalSettings?.additional_settings?.show_on_18_permission === 'global_site'
            );
        },
        isUniPlastHeader() {
            return this.isUniPlast || this.globalSettings?.mainUiInterface?.topNavigationType === 'top_nav_uniplast';
        },
        isStepByStepCart() {
            return this.globalSettings?.mainUiInterface?.cart_button_catalog_view_type === 'step_by_step';
        },
    },

    methods: {
        ...mapActions('cart', ['updateProducts']),
        ...mapActions('calculator', ['fetchMenuData']),
        ...mapMutations({
            SET_LOCALE: 'SET_LOCALE',
            setShowCheckoutModalSuccess: 'cart/setShowCheckoutModalSuccess',
            setProfileDeleteSuccessModal: 'SET_PROFILE_DELETE_SUCCESS_MODAL',
            setMainMenu: 'setMainMenu',
        }),
        stripPTagsDeep(obj) {
            if (typeof obj === 'string') {
                return obj.replace(/<\/?p>/gi, '');
            }
            if (Array.isArray(obj)) {
                return obj.map(this.stripPTagsDeep);
            }
            if (obj && typeof obj === 'object') {
                return Object.entries(obj).reduce((acc, [k, v]) => {
                    acc[k] = this.stripPTagsDeep(v);
                    return acc;
                }, {});
            }
            return obj;
        },
        async fetchMenuList() {
            let menu = await this.$axios.$get('general/menu_tree');
            if (menu.length) {
                this.setMainMenu(menu);
            }
        },
        // Загрузка данных меню с бэкенда
        async loadMenuData() {
            // Проверяем наличие выбранного города
            const selectedCity = this.$store.getters.getSelectedCity;

            if (!selectedCity) {
                console.warn('Город не выбран, невозможно загрузить данные меню');
                return;
            }

            // Проверяем наличие ID города
            if (!selectedCity.id) {
                this.$store.commit('calculator/SET_ERROR', 'Не указан ID города, невозможно загрузить данные меню');
                return;
            }

            try {
                // Устанавливаем состояние загрузки
                this.$store.commit('calculator/SET_LOADING', true);
                this.$store.commit('calculator/SET_ERROR', null);

                // Загружаем данные меню
                await this.fetchMenuData();
                console.log('Данные меню успешно загружены');

                // Генерируем событие загрузки данных меню
                const menuData = this.$store.getters['calculator/getMenuData'];
                emitter.emit('menuDataLoaded', menuData);
            } catch (error) {
                console.error('Ошибка при загрузке данных меню:', error);
                this.$store.commit('calculator/SET_ERROR', 'Ошибка при загрузке данных меню');
            } finally {
                // Снимаем состояние загрузки
                this.$store.commit('calculator/SET_LOADING', false);
            }
        },

        setDefaultAltAttributes() {
            const images = document.querySelectorAll('img');
            images.forEach(img => {
                if (!img.hasAttribute('alt') || img.getAttribute('alt').trim() === '') {
                    img.setAttribute('alt', 'image');
                }
            });
        },
        setGtmPhoneNumber(theCookies) {
            if (window.location.href.includes('utm_source=google') && theCookies) {
                const cookiesArray = theCookies.split(';');
                cookiesArray.forEach(i => {
                    if (i.includes('cookie_changed_phone')) {
                        let rawNum = i.indexOf('+373');

                        if (rawNum !== -1) {
                            let phoneNumber = i.substring(rawNum);
                            try {
                                if (window.sessionStorage) {
                                    window.sessionStorage.setItem('shortLinkPhoneNumber', phoneNumber);
                                }
                            } catch (e) {
                                console.error('Error accessing sessionStorage:', e);
                            }
                        }
                    }
                });
            }
        },
        setFalestiCompanyPhoneNumber() {
            if (window.location.href.includes('utm_content=falesti')) {
                const phoneNumber = '+373 76 08 24 59';
                try {
                    if (window.sessionStorage) {
                        window.sessionStorage.setItem('shortLinkPhoneNumber', phoneNumber);
                    }
                } catch (e) {
                    console.error('Error accessing sessionStorage:', e);
                }
            }
        },
        setNumberToGlobalStore() {
            let phone = null;
            try {
                if (window.sessionStorage) {
                    phone = window.sessionStorage?.getItem('shortLinkPhoneNumber');
                }
            } catch (e) {
                console.error('Error accessing sessionStorage:', e);
            }

            if (phone) {
                this.$store.dispatch('global/setMainPhoneNumber', phone);
            }
        },
        certainAuth() {
            if (this.$cookies.get('token')) {
                this.$store.dispatch('auth/setIsAuth', true);
                // this.$axios.setHeader('shtoken', `${this.$cookies.get('token')}`);
            } else {
                this.$store.dispatch('auth/setIsAuth', false);
                this.$axios.setHeader('Authorization', null);
                if (!this.$route.path.includes('/auth')) window.location = this.localePath('/auth');
                // this.$router.push({ path: this.localePath('/auth') })
            }
        },
        certainResetingAuthData() {
            const isUseAuth = this.globalSettings.additional_settings?.is_user_cabinet || false;

            if (!isUseAuth) this.$store.dispatch('auth/resetAuthData');
        },

        async certainGoogleSocialAuth() {
            const getAccessTokenFromHash = hash => {
                return new URLSearchParams(hash.substring(1)).get('access_token');
            };

            const accessToken = getAccessTokenFromHash(this.$route.hash);

            if (accessToken) {
                await this.$store.dispatch('auth/socialAuthentication', {
                    access: accessToken,
                    strategy: 'google',
                });

                this.$router.push({ ...this.$route, hash: '' });
            }
        },
        async certainAmazonAndLinkedInSocialAuth() {
            try {
                const { code, scope, state } = this.$route.query;

                if (code && scope && state) {
                    await this.$store.dispatch('auth/socialAuthentication', {
                        access: code,
                        strategy: 'amazon',
                        socialUrl: 'amazon-auth',
                    });
                    this.$router.push({ ...this.$route, query: {} });
                    return;
                }
                if (code && state) {
                    await this.$store.dispatch('auth/socialAuthentication', {
                        access: code,
                        strategy: 'linkedin',
                        socialUrl: 'linkedin-auth',
                    });
                    this.$router.push({ ...this.$route, query: {} });
                }
            } catch (e) {
                console.log(e);
            }
        },
        async certainTwitterSocialAuth() {
            try {
                const { oauth_token, oauth_verifier } = this.$route.query;

                if (oauth_token && oauth_verifier) {
                    await this.$store.dispatch('auth/twitterAuthentication', { oauth_token, oauth_verifier });
                    this.$router.push({ ...this.$route, query: {} });
                }
            } catch (e) {
                console.log(e);
            }
        },
        async activateAccount() {
            const { uid, token, reset, deleting, login } = this.$route.query;

            if (login) {
                await this.$store.dispatch('auth/setIsUnauthorized', false);

                await this.$store.dispatch('setShowAuth', true);
                return;
            }
            if (uid && token && reset) {
                this.$store.dispatch('setShowSetNewPassword', true);
            } else if (uid && token && !deleting) {
                await this.$store.dispatch('auth/confirmRegister', {
                    uid,
                    token,
                    executeRedirect: false,
                });
            }
        },
        async successProfileDelete() {
            const { uid, token, deleting, login } = this.$route.query || {};

            if (login) {
                await this.$store.dispatch('auth/setIsUnauthorized', false);
                return;
            }
            if (uid && token && deleting) {
                await this.$store.dispatch('auth/deleteProfile', { uid, token });
                this.setProfileDeleteSuccessModal(true);
            }
        },
        certainModalAgeRestrictionActivness() {
            if (this.isDisplay18YearOldModal) {
                const isTermsPage = this.$route.path.includes('/terms');
                const isAgeValid = this.$cookies.get('is_age_valid');

                if (!isAgeValid && !isTermsPage) this.$store.dispatch('setShowAgeRestriction', true);
            }
        },
        clearWrongLangCookie() {
            const isCorrectLangCookie = this.$i18n.locales.some(item => item.code === this.$cookies.get('language'));
            const isCorrectRedirectLangCookie = this.$i18n.locales.some(
                item => item.code === this.$cookies.get('i18n_redirected')
            );
            if (!isCorrectLangCookie || !isCorrectRedirectLangCookie) {
                this.$cookies.set('language', this.$i18n.locales[0].code);
                this.$cookies.set('i18n_redirected', this.$i18n.locales[0].code);
            }
        },

        insertMetaTag(name, content) {
            const meta = document.createElement('meta');
            meta.setAttribute('name', name);
            meta.setAttribute('content', content);
            document.head.appendChild(meta);
        },

        insertScriptTag(code) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.innerHTML = code;
            document.head.appendChild(script);
        },
    },
    async created() {
        await this.$store.dispatch('auth/initializeAuthListener');
    },
    async mounted() {
        const theCurrency = this.globalSettings.project_currency;

        await this.$store.dispatch('global/setCurrencyLocalization', theCurrency);
        this.subscribeForProductsCartUpdate();
        this.clearWrongLangCookie();
        await this.certainGoogleSocialAuth();
        await this.certainAmazonAndLinkedInSocialAuth();
        await this.successProfileDelete();
        await this.activateAccount();
        await this.certainTwitterSocialAuth();
        if (this.isVitrina) this.certainAuth();
        await this.$store.dispatch('utms/setTheUtms', {
            utm_source: this.$route.query.utm_source || '',
            utm_medium: this.$route.query.utm_medium || '',
            utm_campaign: this.$route.query.utm_campaign || '',
            utm_term: this.$route.query.utm_term || '',
            utm_content: this.$route.query.utm_content || '',
        });
        document.activeElement.blur();

        const observer = new MutationObserver(() => {
            this.setGtmPhoneNumber(document.cookie);
            this.setFalestiCompanyPhoneNumber();
            this.setNumberToGlobalStore();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        this.setDefaultAltAttributes();

        if (this.isStepByStepCart) {
            // Слушаем изменение выбранного города
            emitter.on('cityChanged', this.loadMenuData);

            // Загружаем данные меню при инициализации
            await this.loadMenuData();
        }

        this.$nextTick(() => {
            this.isPageLoaded = true;
        });

        setTimeout(() => {
            const ga4Id = this.$store.state.global.globalSettings?.sitesettingsstatistic?.google_analytics_4;

            if (ga4Id) {
                // Первый скрипт для загрузки gtag.js
                const scriptEl1 = document.createElement('script');
                scriptEl1.async = true;
                scriptEl1.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
                document.head.insertAdjacentElement('afterbegin', scriptEl1);

                // Второй скрипт для конфигурации
                const scriptEl2 = document.createElement('script');
                scriptEl2.innerHTML = `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${ga4Id}');
`;
                document.head.insertAdjacentElement('afterbegin', scriptEl2);
            }

            const gtmId = this.$store.state.global.globalSettings?.sitesettingsstatistic?.google_tag_manager;
            const metaPixelCodeId = this.$store.state.global.globalSettings?.sitesettingsstatistic?.facebook_meta_pixel_code;
            if (gtmId) {
                const scriptEl = document.createElement('script');
                scriptEl.innerHTML = `
            (function(w,d,s,l,i){
                w[l] = w[l] || [];
                w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l !== 'dataLayer' ? '&l='+l : '';
                j.async = true;
                j.src = 'https://www.googletagmanager.com/gtm.js?id='+i+dl;
                f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');
            `;

                document.head.insertAdjacentElement('afterbegin', scriptEl);
            }

            if (gtmId) {
                const gtmNoScript = `
        <!-- Google Tag Manager (noscript) -->
        <noscript>
        <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
                height="0" width="0" style="display:none;visibility:hidden"></iframe>
        </noscript>
        <!-- End Google Tag Manager (noscript) -->
    `;
                document.body.insertAdjacentHTML('afterbegin', gtmNoScript);
            }

            if (metaPixelCodeId) {
                const metaPixelScript = document.createElement('script');
                metaPixelScript.async = true;
                metaPixelScript.text = `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document, 'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${metaPixelCodeId}');
fbq('track', 'PageView');
`;
                // Вставляем созданный <script> в конец тега <head>
                document.head.insertAdjacentElement('beforeend', metaPixelScript);

                // Создаем noscript-блок для Meta Pixel Code
                const metaPixelNoScript = `
<!-- Meta Pixel Code -->
<noscript>
<img height="1" width="1" style="display:none"
   src="https://www.facebook.com/tr?id=${metaPixelCodeId}&ev=PageView&noscript=1"/>
</noscript>
<!-- End Meta Pixel Code -->
`;
                // Вставляем noscript-блок в конец тега <head>
                document.head.insertAdjacentHTML('beforeend', metaPixelNoScript);
            }

            //       const settings = this.$store.state.global.globalSettings?.sitesettingsstatistic;
            //       if (!settings) return;
            //
            //       const {
            //           facebook_verification: facebookVerification,
            //           google_search_console: googleSearchConsole,
            //           google_tag_manager: googleTagManager,
            //           yandex_metrika: yandexMetrika,
            //       } = settings;
            //
            //       // Добавление <meta> тегов
            //       if (facebookVerification) {
            //           this.insertMetaTag('facebook-domain-verification', facebookVerification);
            //       }
            //
            //       if (googleSearchConsole) {
            //           this.insertMetaTag('google-site-verification', googleSearchConsole);
            //       }
            //
            //       // Добавление <script> тегов
            //       if (googleTagManager) {
            //           this.insertScriptTag(`
            //   (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            //   new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            //   j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
            //   j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            //   f.parentNode.insertBefore(j,f);
            //   })(window,document,'script','dataLayer','${googleTagManager}');
            // `);
            //       }
            //
            //       if (yandexMetrika) {
            //           this.insertScriptTag(`
            //   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            //   m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0];
            //   k.async=1;k.src=r;a.parentNode.insertBefore(k,a)})
            //   (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
            //
            //   ym(${yandexMetrika}, "init", {
            //     clickmap:true,
            //     trackLinks:true,
            //     accurateTrackBounce:true
            //   });
            // `);
            //       }
        }, 5000);

        const { city_selection } = this.$route.query;

        if (city_selection === 'true') {
            this.$store.dispatch('setShowCitySelection', true);
        }
    },

    watch: {
        globalSettings: {
            handler() {
                if (this.getLocaleMessagesB2C) {
                    this.$i18n.setLocaleMessage(this.$i18n.locale, {
                        ...this.$i18n.messages[this.$i18n.locale],
                        ...this.getLocaleMessagesB2C,
                    });
                }
                if (this.getLocaleMessagesB2B && this.isHaveCompanyInUserData) {
                    this.$i18n.setLocaleMessage(this.$i18n.locale, {
                        ...this.$i18n.messages[this.$i18n.locale],
                        ...this.getLocaleMessagesB2B,
                    });
                }
            },
            deep: true,
            immediate: true,
        },
        getShowModalSendCvSuccess(newVal) {
            newVal ? document.body.classList.add('popup-open') : document.body.classList.remove('popup-open');
        },
        getShowOneClickModalSuccess(newVal) {
            newVal ? document.body.classList.add('popup-open') : document.body.classList.remove('popup-open');
        },
        getSelectedCity: {
            async handler(newVal) {
                if (newVal) {
                    await this.loadMenuData();
                }
            },
            immediate: true,
        },
        '$i18n.locale': async function (newLocale, oldlocale) {
            await this.$store.dispatch('footer/fetchFooterSettings');
            await this.$store.dispatch('global/fetchGlobalSettings');
            if (this.getLocaleMessagesB2C) {
                this.$i18n.setLocaleMessage(this.$i18n.locale, {
                    ...this.$i18n.messages[this.$i18n.locale],
                    ...this.getLocaleMessagesB2C,
                });
            }
            if (this.getLocaleMessagesB2B && this.isHaveCompanyInUserData) {
                this.$i18n.setLocaleMessage(this.$i18n.locale, {
                    ...this.$i18n.messages[this.$i18n.locale],
                    ...this.getLocaleMessagesB2B,
                });
            }
            await this.fetchMenuList();
            this.$cookies.set('language', newLocale, {
                path: '/',
                maxAge: 60 * 60 * 24 * 365, // 1 год
            });
            this.SET_LOCALE(this.$i18n.locale);

            // const modals = await this.$axios.$get('/base/pop-up-configuration');

            // await this.$store.dispatch('modals/setModals', modals);

            let cart = null;

            if (process.client) {
                JSON.parse(localStorage?.getItem('cart'));
            }

            if (cart) {
                const urlProducts = [];
                const newUrlProducts = [];
                const newProducts = [];

                cart.products.forEach(item => {
                    urlProducts.push(item?.product?.url);
                });

                const promises = urlProducts.map(async item => {
                    try {
                        if (item) {
                            const request = await this.$axios.$post('general/slug_check', {
                                new_lang: this.$i18n.locale,
                                current_slug: item,
                                object_type: 'product',
                            });
                            return request.slug;
                        } else {
                            return item;
                        }
                    } catch {
                        return item;
                    }
                });

                const results = await Promise.all(promises);

                newUrlProducts.push(...results);

                const promisesProducts = newUrlProducts.map(async item => {
                    const request = await this.$axios.$get(`general/product/${item}`);
                    return request.product;
                });

                const resultsProducts = await Promise.all(promisesProducts);

                newProducts.push(...resultsProducts);

                const updatedCart = {
                    ...cart,
                    products: cart.products.map((item, idx) => {
                        return {
                            ...item,
                            product: newProducts[idx],
                        };
                    }),
                };

                localStorage.setItem('cart', JSON.stringify(updatedCart));
                this.updateProducts(updatedCart.products);
            }
        },
        $route: async function (newVal) {
            if (newVal?.query?.login === 'true') {
                await this.$store.dispatch('setShowAuth', true);
            }
            this.certainModalAgeRestrictionActivness();
        },
    },
    async fetch() {
        if (this.getLocaleMessagesB2C) {
            this.$i18n.setLocaleMessage(this.$i18n.locale, {
                ...this.$i18n.messages[this.$i18n.locale],
                ...this.getLocaleMessagesB2C,
            });
        }
        if (this.getLocaleMessagesB2B && this.isHaveCompanyInUserData) {
            this.$i18n.setLocaleMessage(this.$i18n.locale, {
                ...this.$i18n.messages[this.$i18n.locale],
                ...this.getLocaleMessagesB2B,
            });
        }
        this.tempCookieData = this.$cookies.getAll();
        this.certainModalAgeRestrictionActivness();
        this.certainResetingAuthData();
        // const modals = await this.$axios.$get('/base/pop-up-configuration');
        //
        // this.$store.dispatch('modals/setModals', modals);
        if (process.env.LOGIN === 'TRUE') this.$store.dispatch('global/setIsVitrina', true);

        if (this.$cookies.get('token')) {
            this.$axios.setHeader('shtoken', `${this.$cookies.get('token')}`);
        }

        const response = await import('~/testResponseServer.json');

        for (const [key, value] of Object.entries(response.default.mainComponents)) {
            components.push(defineAsyncComponent(() => import(`../components/${key}/viewType${value}.vue`)));
        }

        // await this.$store.dispatch('global/fetchGlobalSettings');
        await this.$store.dispatch('footer/fetchFooterSettings');
        // await this.$store.dispatch('cart/getDeliveryText');

        // if (!this.$cookies.get('language') && this.$store.getters['global/getMainlang'] !== this.$i18n.locale) {
        //     this.$i18n.setLocale(this.$store.getters['global/getMainlang']);
        //     this.$cookies.set('language', this.$i18n.locale);
        // }
    },
    head() {
        // const googleSearchConsole = this.globalSettings?.sitesettingsstatistic?.google_search_console || null;
        // const facebookDomainVerification = this.globalSettings?.sitesettingsstatistic?.facebook_verification || null;
        const scripts = [];
        const styles = [
            {
                hid: 'theme-css-variables',
                innerHTML: this.getCssVariables(),
                type: 'text/css',
            },
        ];
        const metas = [
            {
                hid: 'og:url',
                property: 'og:url',
                content: `${this.$config.PUBLIC_URL.replace(/\/+$/, '')}/${this.$route.path.replace(/^\/+/, '')}`,
            },
            {
                hid: 'og:type',
                property: 'og:type',
                content: this.$route.path.includes('/product') ? 'product' : 'website',
            },
            {
                name: 'color-scheme',
                content: this.getSchemeColor,
            },
        ];
        const noscripts = [];
        const sanitizers = {
            'custom-js': ['innerHTML'],
            'google-analytics-config': ['innerHTML'],
            'google-tag-manager': ['innerHTML'],
            'yandex-metrika': ['innerHTML'],
        };
        let mainFontSizeSource = '';

        const css = this.$store.state.global.globalSettings?.styles?.css;
        const js = this.$store.state.global.globalSettings?.styles?.script;
        // const noScriptText = this.$store.state.global.globalSettings?.styles?.no_script_text;
        const additionalJsItems = this.$store.state.global.globalSettings?.styles?.additional_js_items || [];

        if (this.isCasaDelTabaco) {
            mainFontSizeSource =
                'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Onest:wght@100..900&display=swap';

            // BITRIX CHAT Connection
            scripts.push({
                innerHTML: `
                    (function(w,d,u){
                    var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/60000|0);
                    var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
                    })(window,document,'https://crm.tabak.md/upload/crm/site_button/loader_6_aic4p5.js');
                `,
            });
        }

        const facebookVerification = this.$store.state.global.globalSettings?.sitesettingsstatistic?.facebook_verification;
        // const googleAnalytics4 = this.$store.state.global.globalSettings?.sitesettingsstatistic?.google_analytics_4;
        const googleSearchConsole = this.$store.state.global.globalSettings?.sitesettingsstatistic?.google_search_console;
        // const googleTagManager = this.$store.state.global.globalSettings?.sitesettingsstatistic?.google_tag_manager;
        const yandexMetrika = this.$store.state.global.globalSettings?.sitesettingsstatistic?.yandex_metrika;

        if (facebookVerification) {
            metas.push({
                hid: 'facebook-domain-verification',
                name: 'facebook-domain-verification',
                content: facebookVerification,
            });
        }

        if (googleSearchConsole) {
            metas.push({
                hid: 'google-site-verification',
                name: 'google-site-verification',
                content: googleSearchConsole,
            });
        }

        // if (process.client) {
        // if (googleAnalytics4) {
        // scripts.push({
        //     hid: 'google-analytics-gtag',
        //     src: `https://www.googletagmanager.com/gtag/js?id=${googleAnalytics4}`,
        //     async: true
        // });
        // scripts.push({
        //     hid: 'google-analytics-config',
        //     innerHTML: `
        //             window.dataLayer = window.dataLayer || [];
        //             function gtag(){dataLayer.push(arguments);}
        //             gtag('js', new Date());
        //             gtag('config', '${googleAnalytics4}');
        //         `
        // });
        // }

        // if (googleTagManager) {
        //     scripts.push({
        //         hid: 'google-tag-manager',
        //         innerHTML: `
        //                 (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        //                 var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        //                 j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        //                 })(window,document,'script','dataLayer','${googleTagManager}');
        //             `,
        //     });
        // }

        if (yandexMetrika) {
            scripts.push({
                hid: 'yandex-metrika',
                innerHTML: `
                        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                        m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0];k.async=1;k.src=r;a.parentNode.insertBefore(k,a)})
                        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

                        ym(${yandexMetrika}, "init", {
                            clickmap:true,
                            trackLinks:true,
                            accurateTrackBounce:true
                        });
                    `,
            });
        }
        // }

        if (js) {
            scripts.push({
                hid: 'custom-js',
                innerHTML: js,
                type: 'text/javascript',
            });
        }

        if (css) {
            styles.push({
                hid: 'custom-css',
                innerHTML: css,
                type: 'text/css',
            });
        }

        let url = this.$config.PUBLIC_URL;
        if (url?.endsWith('/')) {
            url = url.slice(0, -1);
        }

        additionalJsItems.forEach((item, index) => {
            if (item.location !== 'head' || !item.script) return;

            const hid = `additional-js-${item.script_type}-${index}`;

            if (item.script_type === 'script') {
                scripts.push({
                    hid,
                    innerHTML: item.script,
                    type: 'text/javascript',
                });
                sanitizers[hid] = ['innerHTML'];
            }

            if (item.script_type === 'noscript') {
                noscripts.push({
                    hid,
                    innerHTML: item.script,
                    body: false,
                });
                sanitizers[hid] = ['innerHTML'];
            }
        });

        return {
            __dangerouslyDisableSanitizersByTagID: sanitizers,
            __dangerouslyDisableSanitizers: ['script'],
            bodyAttrs: {
                style: `font-family: ${this.foundFontFile || 'Helvetica'}, Arial, Roboto, system-ui;`,
                class: [
                    this.currentTheme,
                    this.isNovaPorta ? 'novaporta' : '',
                    this.isHabsev ? 'habsev' : '',
                    this.isCasaDelTabaco ? 'tabaco' : '',
                    this.isDisplayItemsSharp ? '--sharp' : '',
                    this.getIsOpenCart ||
                    this.getIsShowModal ||
                    this.getBuyOneClickShowModal ||
                    this.getModalGift ||
                    this.getModalRequestConsultation ||
                    this.getModalRequestConsultationSuccess ||
                    this.getShowErrorServer ||
                    this.getShowModalActiveVacancy ||
                    this.getShowModalSendCv ||
                    this.getBannerShowContent ||
                    this.showMobileFiltering || //
                    this.showMobileSorting ||
                    this.getShowCheckoutModalSuccess ||
                    this.getShowPaymentModalSuccess ||
                    this.showMenuMobile ||
                    this.getShowNavigationMobile ||
                    this.getShowOneClickModalSuccess ||
                    this.getShowPreorderModalSuccess ||
                    this.getPreorderClickShowModal ||
                    this.getFirstToKnowClickShowModal ||
                    this.getShowFirstToKnowModalSuccess ||
                    this.getShowAgeRestriction ||
                    this.getShowAuth ||
                    this.getShowRegister ||
                    this.getShowRegisterConfirmMessage ||
                    this.getShowSetNewPassword ||
                    this.getShowRequestNewPassword ||
                    this.getShowModal ||
                    this.isModalOrderCheckout ||
                    this.getShowShopModal
                        ? 'popup-open'
                        : '' || this.showMenu
                          ? 'popup-open'
                          : '',
                ],
            },
            htmlAttrs: {
                lang: this.$i18n.locale || 'en',
            },
            style: styles,
            script: scripts,
            link: [
                {
                    rel: 'canonical',
                    href: `${url}${this.$route.path}`,
                },
                {
                    rel: 'shortcut icon',
                    href: this.getFavicon,
                },
                // {
                //     rel: 'preconnect',
                //     href: 'https://fonts.googleapis.com',
                //     crossorigin: true
                // },
                // {
                //     rel: 'preconnect',
                //     href: 'https://fonts.gstatic.com',
                //     crossorigin: true
                // },
                // {
                //     rel: 'preload',
                //     href: 'https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap',
                //     as: 'style'
                // },
                // {
                //     rel: 'stylesheet',
                //     href: require('/assets/fonts/inter.css')
                // },
                // ...(this.foundFontFile ? [] : interFonts),
                {
                    rel: 'stylesheet',
                    href: mainFontSizeSource,
                },
                {
                    rel: 'stylesheet',
                    href: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
                },
            ],
            meta: metas,
        };
    },
};
